import { memo } from 'react'
import { Stack, Subheader3 } from '@collaborate-health/uikit'
import {
  ContentSharingDialogStepId,
  SharingDialogStage,
  SharingDialogStep,
} from '@tabeeb/modules/contentSharings/types'
import UserSelect from '../UserSelect'
import ContentDestination from '../ContentDestination'
import TenantDestination from '../TenantDestination'

interface StepProps {
  step: SharingDialogStep
  stepIndex: number
  currentStage: SharingDialogStage
}

const Step: React.FC<StepProps> = ({ step, stepIndex, currentStage }) => {
  const previousStep = currentStage.steps[stepIndex - 1]
  let isDisabled = false

  if (previousStep) {
    isDisabled = !previousStep.isOptional && !previousStep.isCompleted
  }

  const props = { isDisabled }

  return (
    <Stack>
      <Subheader3>{step.label}</Subheader3>
      {step.id === ContentSharingDialogStepId.SelectTenantDestination && <TenantDestination {...props} />}
      {step.id === ContentSharingDialogStepId.SelectUser && <UserSelect {...props} />}
      {step.id === ContentSharingDialogStepId.SelectContentDestination && <ContentDestination {...props} />}
    </Stack>
  )
}

export default memo(Step)

